<!-- 買う・使う一覧のサムネイル画像表示 -->
<template>
  <div class="book-index-content-left">
    <img class="list-item__thumbnail_book" :src="imageUrl" />
  </div>
</template>

<script>
export default {
  name: "MbIndexThumbnailDisp",
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.book-index-content-left {
  float: left;
  width: 85px;
  max-width: 23vw;
}
.list-item__thumbnail_book {
  width: 85px;
  max-width: 23vw;
  background-size: cover;
}

@media screen and (min-width: 421px) {
  /* 480px以下に適用されるCSS（スマホ用） */
  .book-index-content-left {
    width: 20vw;
  }
  .list-item__thumbnail_book {
    width: 20vw;
  }
}
</style>
